import api from "../../api"
import {

    REGISTER_USER_REQUEST,
    REGISTER_USER_SUCCESS,
    REGISTER_USER_FAIL,
    CLEAR_ERRORS,

    MANUAL_REGISTER_REQUEST,
    MANUAL_REGISTER_SUCCESS,
    MANUAL_REGISTER_FAIL,


    VERIFY_TIME_REQUEST,
    VERIFY_TIME_SUCCESS,
    VERIFY_TIME_FAIL,


    RESEND_EMAIL_REQUEST,
    RESEND_EMAIL_SUCCESS,
    RESEND_EMAIL_FAIL,

    VERIFY_EMAIL_REQUEST,
    VERIFY_EMAIL_SUCCESS,
    VERIFY_EMAIL_FAIL,


    LOGOUT_SUCCESS,
    LOGOUT_FAIL,

    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAIL,

    LOAD_USER_REQUEST,
    LOAD_USER_SUCCESS,
    LOAD_USER_FAIL,

    FORGET_PASSWORD_REQUEST,
    FORGET_PASSWORD_SUCCESS,
    FORGET_PASSWORD_FAIL,

    RESET_PASSWORD_REQUEST,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAIL,


    UPDATE_USER_STATUS_REQUEST,
    UPDATE_USER_STATUS_SUCCESS,
    UPDATE_USER_STATUS_FAIL,



    UPDATE_AVATAR_REQUEST,
    UPDATE_AVATAR_SUCCESS,
    UPDATE_AVATAR_FAIL,

    INVITE_USER_REQUEST,
    INVITE_USER_SUCCESS,
    INVITE_USER_FAIL,


    SAVE_SETTINGS_REQUEST,
    SAVE_SETTINGS_SUCCESS,
    SAVE_SETTINGS_FAIL,


    LOAD_SETTINGS_REQUEST,
    LOAD_SETTINGS_SUCCESS,
    LOAD_SETTINGS_FAIL,


    CREATE_CATEGORY_REQUEST,
    CREATE_CATEGORY_SUCCESS,
    CREATE_CATEGORY_FAIL,

    TOGGLE_CATEGORY_REQUEST,
    TOGGLE_CATEGORY_SUCCESS,
    TOGGLE_CATEGORY_FAIL,

    ALL_CATEGORIES_REQUEST,
    ALL_CATEGORIES_SUCCESS,
    ALL_CATEGORIES_FAIL,


    CREATE_PRODUCT_TYPE_REQUEST,
    CREATE_PRODUCT_TYPE_SUCCESS,
    CREATE_PRODUCT_TYPE_FAIL,

    UPDATE_PRODUCT_TYPE_REQUEST,
    UPDATE_PRODUCT_TYPE_SUCCESS,
    UPDATE_PRODUCT_TYPE_FAIL,

    TOGGLE_PRODUCT_TYPE_REQUEST,
    TOGGLE_PRODUCT_TYPE_SUCCESS,
    TOGGLE_PRODUCT_TYPE_FAIL,

    ALL_PRODUCT_TYPES_REQUEST,
    ALL_PRODUCT_TYPES_SUCCESS,
    ALL_PRODUCT_TYPES_FAIL,

    ADD_DETAILS_REQUEST,
    ADD_DETAILS_SUCCESS,
    ADD_DETAILS_FAIL,


    CHANGE_PASSWORD_REQUEST,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_FAIL,

    ALL_ADMINS_REQUEST,
    ALL_ADMINS_SUCCESS,
    ALL_ADMINS_FAIL,

    ALL_PENDING_USERS_REQUEST,
    ALL_PENDING_USERS_SUCCESS,
    ALL_PENDING_USERS_FAIL,

    VERIFY_TOKEN_REQUEST,
    VERIFY_TOKEN_SUCCESS,
    VERIFY_TOKEN_FAIL,

    ALL_PMM_REQUEST,
    ALL_PMM_SUCCESS,
    ALL_PMM_FAIL,

    USER_DETAILS_REQUEST,
    USER_DETAILS_SUCCESS,
    USER_DETAILS_FAIL,


    ALLOW_EDITING_REQUEST,
    ALLOW_EDITING_SUCCESS,
    ALLOW_EDITING_FAIL,

    CHANGE_ADMIN_REQUEST,
    CHANGE_ADMIN_SUCCESS,
    CHANGE_ADMIN_FAIL,


    ALL_INVITES_REQUEST,
    ALL_INVITES_SUCCESS,
    ALL_INVITES_FAIL,



    CREATE_BLOCKED_EMAIL_REQUEST,
    CREATE_BLOCKED_EMAIL_SUCCESS,
    CREATE_BLOCKED_EMAIL_FAIL,

    ALL_BLOCKED_EMAIL_REQUEST,
    ALL_BLOCKED_EMAIL_SUCCESS,
    ALL_BLOCKED_EMAIL_FAIL,

    DELETE_BLOCKED_EMAIL_REQUEST,
    DELETE_BLOCKED_EMAIL_SUCCESS,
    DELETE_BLOCKED_EMAIL_FAIL,

    CREATE_PRODUCT_MARKET_REQUEST,
    CREATE_PRODUCT_MARKET_SUCCESS,
    CREATE_PRODUCT_MARKET_FAIL,

    TOGGLE_PRODUCT_MARKET_REQUEST,
    TOGGLE_PRODUCT_MARKET_SUCCESS,
    TOGGLE_PRODUCT_MARKET_FAIL,

    ALL_PRODUCT_MARKETS_REQUEST,
    ALL_PRODUCT_MARKETS_SUCCESS,
    ALL_PRODUCT_MARKETS_FAIL,



    APPROVE_USER_REQUEST,
    APPROVE_USER_SUCCESS,
    APPROVE_USER_FAIL,


    CONTACT_REQUEST,
    CONTACT_SUCCESS,
    CONTACT_FAIL,

    CLEAR_MESSAGES,

    UPDATE_CATEGORY_REQUEST,
    UPDATE_CATEGORY_SUCCESS,
    UPDATE_CATEGORY_FAIL,

    DELETE_CATEGORY_REQUEST,
    DELETE_CATEGORY_SUCCESS,
    DELETE_CATEGORY_FAIL,

    UPDATE_PRODUCT_MARKET_REQUEST,
    UPDATE_PRODUCT_MARKET_SUCCESS,
    UPDATE_PRODUCT_MARKET_FAIL,

    DELETE_PRODUCT_MARKET_REQUEST,
    DELETE_PRODUCT_MARKET_SUCCESS,
    DELETE_PRODUCT_MARKET_FAIL,

    DELETE_PRODUCT_TYPE_REQUEST,
    DELETE_PRODUCT_TYPE_SUCCESS,
    DELETE_PRODUCT_TYPE_FAIL,
    ADMIN_UPDATE_USER_CREDENTIALS_REQUEST,
    ADMIN_UPDATE_USER_CREDENTIALS_SUCCESS,
    ADMIN_UPDATE_USER_CREDENTIALS_FAIL,
} from "../constants/userConstant"


export const adminUpdateUserCredentialsAction = (credentialsData) => async (dispatch) => {
    try {
        dispatch({ type: ADMIN_UPDATE_USER_CREDENTIALS_REQUEST });

        const config = { headers: { "Content-Type": "application/json" } };

        const { data } = await api.put(`/api/v1/admin/update-user-credentials`, credentialsData, config);

        dispatch({
            type: ADMIN_UPDATE_USER_CREDENTIALS_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: ADMIN_UPDATE_USER_CREDENTIALS_FAIL,
            payload: error.response?.data?.message || error.message,
        });
    }
};




export const registerAction = (userData) => async (dispatch) => {
    try {
        dispatch({ type: REGISTER_USER_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }

        const { data } = await api.post(`/api/v1/register`, userData, config)
        dispatch({
            type: REGISTER_USER_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: REGISTER_USER_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}
export const ContactAction = (userData) => async (dispatch) => {
    try {
        dispatch({ type: CONTACT_REQUEST })

        const { data } = await api.post(`/api/v1/send-contact-message`, userData)
        dispatch({
            type: CONTACT_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: CONTACT_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}
export const manualRegisterAction = (userData) => async (dispatch) => {
    try {
        dispatch({ type: MANUAL_REGISTER_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }

        const { data } = await api.post(`/api/v1/manual-register`, userData, config)
        dispatch({
            type: MANUAL_REGISTER_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: MANUAL_REGISTER_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}
export const verifyTokenAction = (token) => async (dispatch) => {
    try {
        dispatch({ type: VERIFY_TOKEN_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }

        const { data } = await api.post(`/api/v1/verify-invite-token`, token, config)
        dispatch({
            type: VERIFY_TOKEN_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: VERIFY_TOKEN_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}


export const verifyEmailTimeAction = (email) => async (dispatch) => {
    try {
        dispatch({ type: VERIFY_TIME_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }

        const { data } = await api.post(`/api/v1/email-expiry-time/`, email, config)
        dispatch({
            type: VERIFY_TIME_SUCCESS,
            payload: data.expiryTime,
        })
    } catch (error) {
        dispatch({
            type: VERIFY_TIME_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}

export const resendEmailAction = (email) => async (dispatch) => {
    try {
        dispatch({ type: RESEND_EMAIL_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }

        const { data } = await api.post(`/api/v1/resend-email/`, email, config)
        dispatch({
            type: RESEND_EMAIL_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: RESEND_EMAIL_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}

export const verifyEmailAction = (userData) => async (dispatch) => {
    try {
        dispatch({ type: VERIFY_EMAIL_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }

        const { data } = await api.post(`/api/v1/verify-email/`, userData, config)
        dispatch({
            type: VERIFY_EMAIL_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: VERIFY_EMAIL_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}


export const changePasswordAction = (userData) => async (dispatch) => {
    try {
        dispatch({ type: CHANGE_PASSWORD_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }

        const { data } = await api.put(`/api/v1/change-password`, userData, config)
        dispatch({
            type: CHANGE_PASSWORD_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: CHANGE_PASSWORD_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}
export const allowEditingAction = (id) => async (dispatch) => {
    try {
        dispatch({ type: ALLOW_EDITING_REQUEST })


        const { data } = await api.put(`/api/v1/allow-editing?user_id=${id}`)
        dispatch({
            type: ALLOW_EDITING_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: ALLOW_EDITING_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}
export const changeAdminAction = (userData) => async (dispatch) => {
    try {
        dispatch({ type: CHANGE_ADMIN_REQUEST })

        const config = { headers: { "Content-Type": "application/json" } }


        const { data } = await api.put(`/api/v1/change-admin`, userData, config)
        dispatch({
            type: CHANGE_ADMIN_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: CHANGE_ADMIN_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}


export const LogoutUserAction = () => async (dispatch) => {
    try {

        await api.get(`/api/v1/logout`)
        dispatch({ type: LOGOUT_SUCCESS })
    } catch (error) {
        dispatch({
            type: LOGOUT_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}


export const loginAction = (userData) => async (dispatch) => {
    try {
        dispatch({ type: LOGIN_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }

        console.log('API URL:', process.env.REACT_APP_API_URL);


        const { data } = await api.post(`/api/v1/login/`, userData, config)
        dispatch({
            type: LOGIN_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: LOGIN_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}


export const loadUserAction = () => async (dispatch) => {
    try {
        dispatch({ type: LOAD_USER_REQUEST })

        const { data } = await api.get(`/api/v1/me`)
        dispatch({
            type: LOAD_USER_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: LOAD_USER_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}

export const forgotPasswordAction = (userData) => async (dispatch) => {
    try {
        dispatch({ type: FORGET_PASSWORD_REQUEST })
        console.log(process.env.REACT_APP_API_URL)

        const config = { headers: { "Content-Type": "application/json" } }

        const { data } = await api.post(`/api/v1/forgot-password/`, userData, config)
        dispatch({
            type: FORGET_PASSWORD_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: FORGET_PASSWORD_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}

export const resetPasswordAction = (userData, token) => async (dispatch) => {
    try {
        dispatch({ type: RESET_PASSWORD_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }

        const { data } = await api.put(`/api/v1/reset-password?token=${token}`, userData, config)
        dispatch({
            type: RESET_PASSWORD_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: RESET_PASSWORD_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}



export const InviteUserAction = (userData) => async (dispatch) => {
    try {
        dispatch({ type: INVITE_USER_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }

        const { data } = await api.post(`/api/v1/invite-user`, userData, config)
        dispatch({
            type: INVITE_USER_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: INVITE_USER_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}
export const saveSystemSettingsAction = (settingsData) => async (dispatch) => {
    try {
        dispatch({ type: SAVE_SETTINGS_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }


        const { data } = await api.post(`/api/v1/save-system-settings`, settingsData, config)
        dispatch({
            type: SAVE_SETTINGS_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: SAVE_SETTINGS_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}
export const loadSettingsAction = () => async (dispatch) => {
    try {
        dispatch({ type: LOAD_SETTINGS_REQUEST })

        const { data } = await api.get(`/api/v1/load-system-settings`)
        dispatch({
            type: LOAD_SETTINGS_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: LOAD_SETTINGS_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}

export const createCategoryAction = (categoryData) => async (dispatch) => {
    try {
        dispatch({ type: CREATE_CATEGORY_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }

        const { data } = await api.post(`/api/v1/create-category`, categoryData, config)
        dispatch({
            type: CREATE_CATEGORY_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: CREATE_CATEGORY_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}
export const allCategoriesAction = () => async (dispatch) => {
    try {
        dispatch({ type: ALL_CATEGORIES_REQUEST })

        const { data } = await api.get(`/api/v1/all-categories`)
        dispatch({
            type: ALL_CATEGORIES_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: ALL_CATEGORIES_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}
export const toggleCategoriesAction = (id, is_active) => async (dispatch) => {
    try {
        dispatch({ type: TOGGLE_CATEGORY_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }


        const { data } = await api.put(`/api/v1/toggle-category?id=${id}`, { is_active }, config)
        dispatch({
            type: TOGGLE_CATEGORY_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: TOGGLE_CATEGORY_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}

export const updateCategoryAction = (categoryData) => async (dispatch) => {
    try {
        dispatch({ type: UPDATE_CATEGORY_REQUEST });
        const config = { headers: { "Content-Type": "application/json" } };

        const { data } = await api.put(`/api/v1/update-category`, categoryData, config);
        dispatch({ type: UPDATE_CATEGORY_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: UPDATE_CATEGORY_FAIL, payload: error.response?.data?.message || error.message });
    }
};

export const deleteCategoryAction = (id) => async (dispatch) => {
    try {
        dispatch({ type: DELETE_CATEGORY_REQUEST });

        const { data } = await api.delete(`/api/v1/delete-category?id=${id}`);
        dispatch({ type: DELETE_CATEGORY_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: DELETE_CATEGORY_FAIL, payload: error.response?.data?.message || error.message });
    }
};


export const createProductTypeAction = (typeData) => async (dispatch) => {
    try {
        dispatch({ type: CREATE_PRODUCT_TYPE_REQUEST });
        const config = { headers: { "Content-Type": "application/json" } };

        const { data } = await api.post(`/api/v1/create-product-type`, typeData, config);
        dispatch({ type: CREATE_PRODUCT_TYPE_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: CREATE_PRODUCT_TYPE_FAIL, payload: error.response?.data?.message || error.message });
    }
};
export const updateProductTypeAction = (typeData) => async (dispatch) => {
    try {
        dispatch({ type: UPDATE_PRODUCT_TYPE_REQUEST });


        const { data } = await api.put(`/api/v1/update-product-type`, typeData);
        dispatch({ type: UPDATE_PRODUCT_TYPE_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: UPDATE_PRODUCT_TYPE_FAIL, payload: error.response?.data?.message || error.message });
    }
};

export const allProductTypesAction = () => async (dispatch) => {
    try {
        dispatch({ type: ALL_PRODUCT_TYPES_REQUEST });
        const { data } = await api.get(`/api/v1/all-product-types`);
        dispatch({ type: ALL_PRODUCT_TYPES_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: ALL_PRODUCT_TYPES_FAIL, payload: error.response?.data?.message || error.message });
    }
};

export const toggleProductTypesAction = (id, is_active) => async (dispatch) => {
    try {
        dispatch({ type: TOGGLE_PRODUCT_TYPE_REQUEST });
        const config = { headers: { "Content-Type": "application/json" } };

        const { data } = await api.put(`/api/v1/toggle-product-type?id=${id}`, { is_active }, config);
        dispatch({ type: TOGGLE_PRODUCT_TYPE_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: TOGGLE_PRODUCT_TYPE_FAIL, payload: error.response?.data?.message || error.message });
    }
};

export const deleteProductTypeAction = (id) => async (dispatch) => {
    try {
        dispatch({ type: DELETE_PRODUCT_TYPE_REQUEST });

        const { data } = await api.delete(`/api/v1/delete-product-type?id=${id}`);
        dispatch({ type: DELETE_PRODUCT_TYPE_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: DELETE_PRODUCT_TYPE_FAIL, payload: error.response?.data?.message || error.message });
    }
};



export const addDetailsAction = (userData) => async (dispatch) => {
    try {
        dispatch({ type: ADD_DETAILS_REQUEST })

        const { data } = await api.put(`/api/v1/user/profile/update`, userData)
        dispatch({
            type: ADD_DETAILS_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: ADD_DETAILS_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}


export const addOtherUserDetails = (userData, id) => async (dispatch) => {
    try {
        dispatch({ type: ADD_DETAILS_REQUEST })

        const { data } = await api.put(`/api/v1/user/profile/update/other?user_id=${id}`, userData)
        dispatch({
            type: ADD_DETAILS_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: ADD_DETAILS_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}






export const allAdminsAction = (queryParams = {}) => async (dispatch) => {
    try {
        dispatch({ type: ALL_ADMINS_REQUEST })

        const queryString = new URLSearchParams(queryParams).toString();
        const url = queryString ? `/api/v1/view-all-admins?${queryString}` : `/api/v1/view-all-admins`;

        const { data } = await api.get(url);
        dispatch({
            type: ALL_ADMINS_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: ALL_ADMINS_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}
export const allPendingUsersAction = (queryParams = {}) => async (dispatch) => {
    try {
        dispatch({ type: ALL_PENDING_USERS_REQUEST })

        const queryString = new URLSearchParams(queryParams).toString();
        const url = queryString ? `/api/v1/view-all-pending-approval-users?${queryString}` : `/api/v1/view-all-pending-approval-users`;

        const { data } = await api.get(url);
        dispatch({
            type: ALL_PENDING_USERS_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: ALL_PENDING_USERS_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}

export const allPmmsAction = (queryParams = {}) => async (dispatch) => {
    try {
        dispatch({ type: ALL_PMM_REQUEST })

        const queryString = new URLSearchParams(queryParams).toString();
        const url = queryString ? `/api/v1/view-all-pmms?${queryString}` : `/api/v1/view-all-pmms`;

        const { data } = await api.get(url);
        dispatch({
            type: ALL_PMM_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: ALL_PMM_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}
export const allInvitesAction = (queryParams = {}) => async (dispatch) => {
    try {
        dispatch({ type: ALL_INVITES_REQUEST })

        const queryString = new URLSearchParams(queryParams).toString();
        const url = queryString ? `/api/v1/all-invites?${queryString}` : `/api/v1/all-invites`;

        const { data } = await api.get(url);
        dispatch({
            type: ALL_INVITES_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: ALL_INVITES_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}


export const userDetailsAction = (id) => async (dispatch) => {
    try {
        dispatch({ type: USER_DETAILS_REQUEST })

        const url = `/api/v1/single-user?user_id=${id}`;

        const { data } = await api.get(url);
        dispatch({
            type: USER_DETAILS_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: USER_DETAILS_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}




export const UpdateStatusAction = (userData) => async (dispatch) => {
    try {
        dispatch({ type: UPDATE_USER_STATUS_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }


        const { data } = await api.put(`/api/v1/update-user-status`, userData, config)
        dispatch({
            type: UPDATE_USER_STATUS_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: UPDATE_USER_STATUS_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}
export const approveUserAction = (userData) => async (dispatch) => {
    try {
        dispatch({ type: APPROVE_USER_REQUEST })


        const { data } = await api.put(`/api/v1/approve-user`, userData)
        dispatch({
            type: APPROVE_USER_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: APPROVE_USER_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}
export const cancelInvitationAction = (userData) => async (dispatch) => {
    try {
        dispatch({ type: UPDATE_USER_STATUS_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }


        const { data } = await api.put(`/api/v1/cancel-invite`, userData, config)
        dispatch({
            type: UPDATE_USER_STATUS_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: UPDATE_USER_STATUS_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}
export const blockAdminAction = (userData) => async (dispatch) => {
    try {
        dispatch({ type: UPDATE_USER_STATUS_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }


        const { data } = await api.put(`/api/v1/block-user`, userData, config)
        dispatch({
            type: UPDATE_USER_STATUS_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: UPDATE_USER_STATUS_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}



export const updateAvatarAction = (userData) => async (dispatch) => {
    try {
        dispatch({ type: UPDATE_AVATAR_REQUEST })

        const { data } = await api.put(`/api/v1/update-avatar`, userData)

        dispatch({
            type: UPDATE_AVATAR_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: UPDATE_AVATAR_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}
export const createBlockeEmailAction = (userData) => async (dispatch) => {
    try {
        dispatch({ type: CREATE_BLOCKED_EMAIL_REQUEST })
        const config = { headers: { "Content-Type": "application/json" } }

        const { data } = await api.post(`/api/v1/add-blocked-email`, userData, config)
        dispatch({
            type: CREATE_BLOCKED_EMAIL_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: CREATE_BLOCKED_EMAIL_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}
export const deleteBlockeEmailAction = (emailVal) => async (dispatch) => {
    try {
        dispatch({ type: DELETE_BLOCKED_EMAIL_REQUEST })


        const { data } = await api.delete(`/api/v1/delete-blocked-email?email=${emailVal}`)
        dispatch({
            type: DELETE_BLOCKED_EMAIL_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: DELETE_BLOCKED_EMAIL_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}


export const allBlockedEmailsAction = (queryParams = {}) => async (dispatch) => {
    try {
        dispatch({ type: ALL_BLOCKED_EMAIL_REQUEST })

        const queryString = new URLSearchParams(queryParams).toString();
        const url = queryString ? `/api/v1/all-blocked-email?${queryString}` : `/api/v1/all-blocked-email`;

        const { data } = await api.get(url);
        dispatch({
            type: ALL_BLOCKED_EMAIL_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: ALL_BLOCKED_EMAIL_FAIL,
            payload: error.response?.data?.message || error.message,
        })
    }
}




export const createProductMarketAction = (typeData) => async (dispatch) => {
    try {
        dispatch({ type: CREATE_PRODUCT_MARKET_REQUEST });
        const config = { headers: { "Content-Type": "application/json" } };

        const { data } = await api.post(`/api/v1/create-product-market`, typeData, config);
        dispatch({ type: CREATE_PRODUCT_MARKET_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: CREATE_PRODUCT_MARKET_FAIL, payload: error.response?.data?.message || error.message });
    }
};

export const allProductMarketsAction = () => async (dispatch) => {
    try {
        dispatch({ type: ALL_PRODUCT_MARKETS_REQUEST });
        const { data } = await api.get(`/api/v1/all-product-markets`);
        dispatch({ type: ALL_PRODUCT_MARKETS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: ALL_PRODUCT_MARKETS_FAIL, payload: error.response?.data?.message || error.message });
    }
};

export const toggleProductMarketsAction = (id, is_active) => async (dispatch) => {
    try {
        dispatch({ type: TOGGLE_PRODUCT_MARKET_REQUEST });
        const config = { headers: { "Content-Type": "application/json" } };

        const { data } = await api.put(`/api/v1/toggle-product-market?id=${id}`, { is_active }, config);
        dispatch({ type: TOGGLE_PRODUCT_MARKET_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: TOGGLE_PRODUCT_MARKET_FAIL, payload: error.response?.data?.message || error.message });
    }
};

export const updateProductMarketAction = (marketData) => async (dispatch) => {
    try {
        dispatch({ type: UPDATE_PRODUCT_MARKET_REQUEST });
        const config = { headers: { "Content-Type": "application/json" } };

        const { data } = await api.put(`/api/v1/update-product-market`, marketData, config);
        dispatch({ type: UPDATE_PRODUCT_MARKET_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: UPDATE_PRODUCT_MARKET_FAIL, payload: error.response?.data?.message || error.message });
    }
};

export const deleteProductMarketAction = (id) => async (dispatch) => {
    try {
        dispatch({ type: DELETE_PRODUCT_MARKET_REQUEST });

        const { data } = await api.delete(`/api/v1/delete-product-market?id=${id}`);
        dispatch({ type: DELETE_PRODUCT_MARKET_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: DELETE_PRODUCT_MARKET_FAIL, payload: error.response?.data?.message || error.message });
    }
};



export const clearMessage = () => async (dispatch) => {
    dispatch({ type: CLEAR_MESSAGES })
}

export const clearErrors = () => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS })
}
